import { apiClient } from './client';
import type {
  LearningArea,
  LearningOutcome,
} from '../../types/api';

const BASE_URL = '/curriculum';

export interface ListOutcomesParams {
  learning_area_id?: string;
  grade_id?: string;
  is_active?: boolean;
  skip?: number;
  limit?: number;
}

export const curriculumApi = {
  /** List Learning Areas (one per curriculum subject, e.g. Mathematics). */
  async listAreas(): Promise<LearningArea[]> {
    const response = await apiClient.get(`${BASE_URL}/areas`);
    return response.data;
  },

  /** List CAPS Learning Outcomes, optionally filtered by area or grade. */
  async listOutcomes(params?: ListOutcomesParams): Promise<LearningOutcome[]> {
    const response = await apiClient.get(`${BASE_URL}/outcomes`, { params });
    return response.data;
  },
};
